<template>
  <div id="app">

    <Navigation v-if="isLoggedIn"></Navigation>
    <router-view/>
    <Footer v-if="isLoggedIn"></Footer>
  </div>
</template>

<script>

  import Navigation from './components/Navigation.vue'
  import Footer from './components/Footer.vue'


  import './assets/styles/style.css'
  import './assets/styles/framework.css'
  
export default {
    components: { Navigation,Footer },
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },

created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch(logout)
          }
          throw err;
        });
      });
    },

    // Al navegar en una SPA, el tema NO re-dibuja los íconos data-feather del
    // nuevo contenido (feather.replace() solo corre 1 vez al cargar). Por eso al
    // cambiar de menú el footer quedaba sin íconos / desarmado. Aquí re-aplicamos
    // los íconos después de cada render (montaje + cada cambio de ruta).
    mounted: function () {
      this.refreshIcons()
    },

    watch: {
      '$route': function () {
        this.refreshIcons()
      }
    },

    methods: {
      refreshIcons: function () {
        this.$nextTick(function () {
          var tries = 0
          var apply = function () {
            var jq = window.jQuery || window.$
            if (window.feather && jq) {
              // 1) Convierte los <i data-feather="..."> en SVG
              window.feather.replace()
              // 2) Aplica tamaño/grosor desde los data-attributes (igual que el tema)
              jq('.feather').each(function () {
                jq(this).attr('stroke-width', jq(this).data('feather-line'))
                jq(this).attr('width', jq(this).data('feather-size'))
                jq(this).attr('height', jq(this).data('feather-size'))
                jq(this).css('width', jq(this).data('feather-size'))
                jq(this).css('height', jq(this).data('feather-size'))
              })
            } else if (tries++ < 20) {
              // Por si feather/jQuery aún no cargaron (orden de scripts en una recarga)
              setTimeout(apply, 100)
            }
          }
          apply()
        })
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  cursor: pointer;
}

#nav a:hover {
  text-decoration: underline;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
